import { useState } from 'react';
import { Button, useUpdate } from 'react-admin';
import { SwapHoriz } from '@mui/icons-material';
import { dataProvider } from '../../firebase';
import { ISpeaker } from '../../types';

const BulkSwapLastNameButton = (props: any) => {
  const { selectedIds } = props;
  const [update] = useUpdate();
  const [isDone, setIsDone] = useState(false);

  const doSwap = async () => {
    setIsDone(true);
    const proms = selectedIds.map(async (sid: string) => {
      const dt = (await dataProvider.getOne('speakers', { id: sid })).data as ISpeaker;
      update('speakers', { id: sid, data: { lastname: dt.firstname, firstname: dt.lastname } });
    });
    await Promise.all(proms);
    setIsDone(false);
  };

  return (
    <Button label="swap nombre/apellido" disabled={isDone} onClick={doSwap}>
      <SwapHoriz />
    </Button>
  );
};

export default BulkSwapLastNameButton;
